import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      const user = await login(email, password);
      // site_manager ("סייר") goes to /guard - which itself decides whether to show the
      // simplified single-site floor-plan view or fall back to the normal מוקד screen,
      // depending on how many sites they're assigned and whether that site has a floor
      // plan. moked_operator/cross_municipal keep going straight to the normal מוקד.
      const dest = user.role === 'site_manager' ? '/guard'
        : (user.role === 'moked_operator' ? '/moked' : '/admin');
      navigate(dest);
    } catch { setError('אימייל או סיסמה שגויים'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{minHeight:'100vh',background:'#060d1a',display:'flex',alignItems:'center',justifyContent:'center',position:'relative',overflow:'hidden'}}>
      <div style={{position:'absolute',inset:0,backgroundImage:'linear-gradient(rgba(30,61,100,0.3) 1px,transparent 1px),linear-gradient(90deg,rgba(30,61,100,0.3) 1px,transparent 1px)',backgroundSize:'40px 40px'}}/>
      <div style={{position:'relative',width:380,background:'#0a1628',border:'2px solid #1e3a5f',borderRadius:16,overflow:'hidden',boxShadow:'0 0 60px rgba(29,78,216,0.15)'}}>
        <div style={{background:'#0d1f3a',padding:'28px 32px 20px',borderBottom:'2px solid #1e3a5f',textAlign:'center'}}>
          <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:12,marginBottom:8}}>
            <div style={{width:44,height:44,background:'#1d4ed8',border:'2px solid #f97316',borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,fontWeight:800,color:'#fff'}}>SS</div>
            <div style={{textAlign:'right'}}>
              <div style={{fontSize:20,fontWeight:800,color:'#fff',letterSpacing:1}}>SEM SIM</div>
              <div style={{fontSize:10,color:'#f97316',letterSpacing:2,fontWeight:700}}>CUTTING-EDGE WIRELESS</div>
            </div>
          </div>
          <div style={{fontSize:12,color:'#64748b',marginTop:4,letterSpacing:0.5}}>מרכז בקרה — לחצני מצוקה</div>
        </div>
        <div style={{padding:'28px 32px'}}>
          <form onSubmit={handleSubmit} style={{display:'flex',flexDirection:'column',gap:14}} dir="rtl">
            <div>
              <label style={{fontSize:11,fontWeight:700,color:'#94a3b8',letterSpacing:1,display:'block',marginBottom:6}}>אימייל</label>
              <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required autoFocus
                style={{width:'100%',padding:'11px 14px',background:'#060d1a',border:'2px solid #1e3a5f',borderRadius:8,fontSize:14,color:'#f1f5f9',outline:'none',fontFamily:'inherit',boxSizing:'border-box'}}/>
            </div>
            <div>
              <label style={{fontSize:11,fontWeight:700,color:'#94a3b8',letterSpacing:1,display:'block',marginBottom:6}}>סיסמה</label>
              <input type="password" value={password} onChange={e=>setPassword(e.target.value)} required
                style={{width:'100%',padding:'11px 14px',background:'#060d1a',border:'2px solid #1e3a5f',borderRadius:8,fontSize:14,color:'#f1f5f9',outline:'none',fontFamily:'inherit',boxSizing:'border-box'}}/>
            </div>
            {error && <div style={{background:'rgba(239,68,68,0.15)',border:'1px solid rgba(239,68,68,0.4)',color:'#fca5a5',borderRadius:8,padding:'10px 14px',fontSize:13,fontWeight:600}}>{error}</div>}
            <button type="submit" disabled={loading}
              style={{padding:'12px',background:loading?'#1e3a5f':'#1d4ed8',color:'#fff',border:'2px solid #3b82f6',borderRadius:8,fontSize:14,fontWeight:700,cursor:loading?'wait':'pointer',letterSpacing:0.5,marginTop:4}}>
              {loading ? 'מתחבר...' : 'כניסה למערכת'}
            </button>
          </form>
        </div>
        <div style={{padding:'12px 32px',background:'#060d1a',borderTop:'1px solid #1e3a5f',textAlign:'center',fontSize:11,color:'#334155'}}>
          SEM SIM © 2025 — All rights reserved
        </div>
      </div>
    </div>
  );
}
